import { ProductDtoAttributes } from "../../../product/Product"

export type ProductItemDto = {
    id: string
} & ProductDtoAttributes

export class ProductItem {
    private dto: ProductItemDto

    constructor(dto: ProductItemDto) {
        this.dto = dto
    }

    getDto(): ProductItemDto {
        return this.dto
    }
}


// WEBPACK FOOTER //
// ./src/state/listing/product/models/productItem.ts